/*
 * GRIG homepage 2, S9 boxes helpers (sections/grig-home-boxes.liquid, styles in grig-home-boxes.css). Port of the
 * parts of assets/nl-w2-lines.js that the foundation <gh-rail> (assets/grig-home.js) does not cover:
 *   [data-ghl-current]   "01 / 03" counter text, follows the scroll position (same rounding as NaturLabs)
 *   pointer spotlight    .ghl-tile gets --spot-x / --spot-y (px) once per frame, fine pointers only, never with
 *                        reduced motion or the theme motion switch off
 *   theme editor         selecting a box block scrolls the rail to it
 * The meter thumb, arrows, drag, snap and data-no-overflow come from <gh-rail>. Registered through the
 * GRIGHomeReady queue (this script runs before grig-home.js); passive listeners, transform only.
 */
(function () {
  'use strict';

  // Two instances of the section load this file twice: register once (same guard as grig-home-hotspots.js)
  if (window.GRIGHomeBoxes) return;
  window.GRIGHomeBoxes = { version: '1.0.0' };

  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(section, GH) {
    var rail = section.querySelector('gh-rail');
    var track = section.querySelector('[data-rail-track]');
    var current = section.querySelector('[data-ghl-current]');
    var off = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      off.push(function () { target.removeEventListener(type, handler, options); });
    }

    /* Counter: index = round(progress * (total - 1)) + 1, like <nl-w2-rail-progress> */
    if (track && current) {
      var frame = null;
      var render = function () {
        frame = null;
        var total = track.children.length;
        if (!total) return;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var progress = max > 1 ? Math.min(1, Math.max(0, Math.abs(track.scrollLeft) / max)) : 0;
        var text = String(Math.round(progress * (total - 1)) + 1);
        if (text.length < 2) text = '0' + text;
        if (current.textContent !== text) current.textContent = text;
      };
      var queue = function () {
        if (!frame) frame = requestAnimationFrame(render);
      };
      listen(track, 'scroll', queue, { passive: true });
      if (rail) listen(rail, 'gh-rail:update', queue);
      off.push(function () { if (frame) cancelAnimationFrame(frame); });
      render();
    }

    /* Pointer spotlight on the tiles of this section */
    var spotFrame = null;
    var spotTarget = null;
    var spotX = 0;
    var spotY = 0;
    listen(section, 'pointermove', function (event) {
      if (event.pointerType !== 'mouse' || !mqFine.matches || GH.reduced()) return;
      var tile = event.target instanceof Element ? event.target.closest('.ghl-tile') : null;
      if (!tile) return;
      var rect = tile.getBoundingClientRect();
      spotTarget = tile;
      spotX = event.clientX - rect.left;
      spotY = event.clientY - rect.top;
      if (spotFrame) return;
      spotFrame = requestAnimationFrame(function () {
        spotFrame = null;
        if (!spotTarget) return;
        spotTarget.style.setProperty('--spot-x', spotX.toFixed(1) + 'px');
        spotTarget.style.setProperty('--spot-y', spotY.toFixed(1) + 'px');
      });
    }, { passive: true });
    off.push(function () { if (spotFrame) cancelAnimationFrame(spotFrame); });

    /* Theme editor: bring the selected box into view inside the rail */
    listen(document, 'shopify:block:select', function (event) {
      var item = event.target;
      if (!(item instanceof Element) || !track || !track.contains(item)) return;
      var li = item.closest('.ghl__item');
      var index = Array.prototype.indexOf.call(track.children, li);
      if (index < 0) return;
      if (rail && typeof rail.scrollToIndex === 'function') rail.scrollToIndex(index);
    });

    return function () {
      off.forEach(function (fn) { fn(); });
      off = [];
    };
  }

  (window.GRIGHomeReady = window.GRIGHomeReady || []).push(function (GH) {
    GH.register('boxes', function (section) { return init(section, GH); });
  });
})();
